import { createContext } from "react";

export const FieldContext = createContext<{ grid: boolean; inline: boolean }>({
  inline: false,
  grid: false,
});
